const dysphagia =[

    { 
    label:"Frequency:",
    controlType:"radio button",
    options:["Occasonal", "Frequent","Continuous"]
    },

    { 
    label:"Extent:",
    controlType:"radio button",
    options:["For solids", "For Liquids","For saliva"],
    },

    { 
    label:"Present for several:",
    controlType:"radio button",
    options:["Days", "Weeks","Months","Years"]
    }




]


export default dysphagia